import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useMediaUpload } from "./useMediaUpload";

/** All state/handlers for the Admin > Videos destacados tab: link/upload add, thumbnails, save. */
export const useVideoManager = () => {
  const [videos, setVideos] = useState([]);
  const [mode, setMode] = useState("link");
  const [newTitle, setNewTitle] = useState("");
  const [newUrl, setNewUrl] = useState("");
  const [newThumbnail, setNewThumbnail] = useState("");
  const [saving, setSaving] = useState(false);
  const { busyKey, upload } = useMediaUpload();

  useEffect(() => {
    api.get("/content").then((r) => setVideos(r.data.videos || []));
  }, []);

  const addLink = () => {
    if (!newUrl.trim()) return;
    setVideos((v) => [...v, { title: newTitle, url: newUrl, type: "link", thumbnail: newThumbnail }]);
    setNewTitle("");
    setNewUrl("");
    setNewThumbnail("");
  };

  const handleFileUpload = (e) => upload(e, {
    type: "video",
    key: "video",
    successMessage: "Video subido. Haz clic en 'Guardar videos' para publicarlo.",
    errorMessage: "Error al subir el video (máx. 50MB, formatos mp4/mov/webm)",
    onSuccess: (url) => {
      setVideos((v) => [...v, { title: newTitle, url, type: "file", thumbnail: newThumbnail }]);
      setNewTitle("");
      setNewThumbnail("");
    },
  });

  const handleNewThumbnailUpload = (e) => upload(e, {
    type: "image",
    key: "new",
    successMessage: "Portada seleccionada",
    errorMessage: "Error al subir la portada",
    onSuccess: setNewThumbnail,
  });

  const handleExistingThumbnailUpload = (e, idx) => upload(e, {
    type: "image",
    key: idx,
    successMessage: "Portada actualizada. Haz clic en 'Guardar videos' para aplicarla.",
    errorMessage: "Error al subir la portada",
    onSuccess: (url) => setVideos((v) => v.map((vid, i) => (i === idx ? { ...vid, thumbnail: url } : vid))),
  });

  const removeVideo = (idx) => setVideos((v) => v.filter((_, i) => i !== idx));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", { videos });
      toast.success("Videos actualizados");
    } catch {
      toast.error("Error al guardar videos");
    } finally {
      setSaving(false);
    }
  };

  return {
    videos, mode, setMode, newTitle, setNewTitle, newUrl, setNewUrl, newThumbnail,
    saving, busyKey, addLink, handleFileUpload, handleNewThumbnailUpload,
    handleExistingThumbnailUpload, removeVideo, save,
  };
};
